import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Chat() {
  return (
    <section className="solution_amj p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>2. Chat</h2>
            <p>
              No more fixing tee times on WhatsApp or iMessages. Chat with
              golfer friends and stores within the app only!
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <StaticImage
              src="../../../images/case-studies/teemates/chat.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={945}
              height={570}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Chat;
